import { Helmet } from 'react-helmet';
import '../assets/styles/Careers.css';

function Careers() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Careers</title>
        <meta name="description" content="Join the RFF Cargo team and explore career opportunities in logistics." />
      </Helmet>
      <section className="careers-section py-5">
        <div className="container">
          <h2 className="careers-title fw-bold mb-4">Careers</h2>
          <p className="careers-description">
            Discover exciting career opportunities at RFF Cargo and be part of our global logistics team.
          </p>
          <div className="row">
            {/* Left Column: Two Accordions */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="accordion careers-accordion" id="careersAccordionLeft">
                {/* Job 1: Logistics Coordinator */}
                <div className="accordion-item careers-accordion-item">
                  <h2 className="accordion-header careers-accordion-header" id="headingOne">
                    <button
                      className="accordion-button careers-accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Logistics Coordinator (Mombasa, Kenya)
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#careersAccordionLeft"
                  >
                    <div className="accordion-body careers-accordion-body">
                      <h3 className="careers-job-title fw-bold mb-2">Description</h3>
                      <p className="careers-job-text">
                        The Logistics Coordinator will manage shipment logistics, ensuring efficient coordination between clients, carriers, and internal teams to deliver cargo on time.
                      </p>
                      <h3 className="careers-job-title fw-bold mb-2">Responsibilities</h3>
                      <ul className="careers-job-list">
                        <li>Plan and optimize shipment routes for cost and time efficiency.</li>
                        <li>Track shipments using RFF Cargo’s advanced tracking system.</li>
                        <li>Communicate with clients to provide updates and resolve issues.</li>
                        <li>Coordinate with carriers to ensure timely pickup and delivery.</li>
                      </ul>
                      <h3 className="careers-job-title fw-bold mb-2">Qualifications</h3>
                      <ul className="careers-job-list">
                        <li>Bachelor’s degree in logistics, supply chain, or related field.</li>
                        <li>2+ years of experience in logistics or freight forwarding.</li>
                        <li>Proficiency in shipment tracking software and MS Office.</li>
                        <li>Strong organizational and communication skills.</li>
                      </ul>
                      <h3 className="careers-job-title fw-bold mb-2">Application</h3>
                      <p className="careers-job-text">
                        To apply, please send your resume and a cover letter to{' '}
                        <a href="mailto:mhareed@rffcargo.co.ke" aria-label="Email for Logistics Coordinator application">
                          mhareed@rffcargo.co.ke
                        </a>{' '}
                        with the subject line “Logistics Coordinator Application.”
                      </p>
                    </div>
                  </div>
                </div>
                {/* Job 2: Customer Service Representative */}
                <div className="accordion-item careers-accordion-item">
                  <h2 className="accordion-header careers-accordion-header" id="headingTwo">
                    <button
                      className="accordion-button careers-accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Customer Service Representative (Mumbai, India)
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#careersAccordionLeft"
                  >
                    <div className="accordion-body careers-accordion-body">
                      <h3 className="careers-job-title fw-bold mb-2">Description</h3>
                      <p className="careers-job-text">
                        The Customer Service Representative will provide exceptional support to clients, handling inquiries, processing quote requests, and resolving issues promptly.
                      </p>
                      <h3 className="careers-job-title fw-bold mb-2">Responsibilities</h3>
                      <ul className="careers-job-list">
                        <li>Respond to client inquiries via phone, email, and chat.</li>
                        <li>Process and follow up on quote requests within 24 hours.</li>
                        <li>Resolve client issues with professionalism and efficiency.</li>
                        <li>Maintain accurate records of client interactions.</li>
                      </ul>
                      <h3 className="careers-job-title fw-bold mb-2">Qualifications</h3>
                      <ul className="careers-job-list">
                        <li>High school diploma; bachelor’s degree preferred.</li>
                        <li>1+ year of experience in customer service.</li>
                        <li>Excellent verbal and written communication skills.</li>
                        <li>Ability to work in a fast-paced environment.</li>
                      </ul>
                      <h3 className="careers-job-title fw-bold mb-2">Application</h3>
                      <p className="careers-job-text">
                        To apply, please send your resume and a cover letter to{' '}
                        <a href="mailto:mhareed@rffcargo.co.ke" aria-label="Email for Customer Service Representative application">
                          mhareed@rffcargo.co.ke
                        </a>{' '}
                        with the subject line “Customer Service Representative Application.”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Column: Two Accordions */}
            <div className="col-lg-6">
              <div className="accordion careers-accordion" id="careersAccordionRight">
                {/* Job 3: IT Support Specialist */}
                <div className="accordion-item careers-accordion-item">
                  <h2 className="accordion-header careers-accordion-header" id="headingThree">
                    <button
                      className="accordion-button careers-accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="true"
                      aria-controls="collapseThree"
                    >
                      IT Support Specialist (Dubai, UAE)
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingThree"
                    data-bs-parent="#careersAccordionRight"
                  >
                    <div className="accordion-body careers-accordion-body">
                      <h3 className="careers-job-title fw-bold mb-2">Description</h3>
                      <p className="careers-job-text">
                        The IT Support Specialist will maintain and enhance IT systems critical to RFF Cargo’s shipment tracking and logistics operations.
                      </p>
                      <h3 className="careers-job-title fw-bold mb-2">Responsibilities</h3>
                      <ul className="careers-job-list">
                        <li>Troubleshoot and resolve software and hardware issues.</li>
                        <li>Manage and optimize logistics databases and tracking systems.</li>
                        <li>Implement security measures to protect sensitive data.</li>
                        <li>Provide technical support to staff across global offices.</li>
                      </ul>
                      <h3 className="careers-job-title fw-bold mb-2">Qualifications</h3>
                      <ul className="careers-job-list">
                        <li>Bachelor’s degree in IT, computer science, or related field.</li>
                        <li>3+ years of experience in IT support or systems administration.</li>
                        <li>Knowledge of logistics software and database management.</li>
                        <li>Strong problem-solving and teamwork skills.</li>
                      </ul>
                      <h3 className="careers-job-title fw-bold mb-2">Application</h3>
                      <p className="careers-job-text">
                        To apply, please send your resume, cover letter, and relevant certifications to{' '}
                        <a href="mailto:mhareed@rffcargo.co.ke" aria-label="Email for IT Support Specialist application">
                          mhareed@rffcargo.co.ke
                        </a>{' '}
                        with the subject line “IT Support Specialist Application.”
                      </p>
                    </div>
                  </div>
                </div>
                {/* Job 4: Operations Manager */}
                <div className="accordion-item careers-accordion-item">
                  <h2 className="accordion-header careers-accordion-header" id="headingFour">
                    <button
                      className="accordion-button careers-accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Operations Manager (Mombasa, Kenya)
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#careersAccordionRight"
                  >
                    <div className="accordion-body careers-accordion-body">
                      <h3 className="careers-job-title fw-bold mb-2">Description</h3>
                      <p className="careers-job-text">
                        The Operations Manager will oversee logistics operations, lead teams, and ensure efficient and compliant service delivery across RFF Cargo’s operations.
                      </p>
                      <h3 className="careers-job-title fw-bold mb-2">Responsibilities</h3>
                      <ul className="careers-job-list">
                        <li>Manage logistics teams to meet performance targets.</li>
                        <li>Optimize operational processes for efficiency and cost savings.</li>
                        <li>Ensure compliance with international shipping regulations.</li>
                        <li>Develop strategies to enhance service delivery.</li>
                      </ul>
                      <h3 className="careers-job-title fw-bold mb-2">Qualifications</h3>
                      <ul className="careers-job-list">
                        <li>Bachelor’s degree in business, logistics, or related field.</li>
                        <li>5+ years of experience in logistics management.</li>
                        <li>Proven leadership and strategic planning skills.</li>
                        <li>Familiarity with global logistics regulations.</li>
                      </ul>
                      <h3 className="careers-job-title fw-bold mb-2">Application</h3>
                      <p className="careers-job-text">
                        To apply, please send your resume, cover letter, and two professional references to{' '}
                        <a href="mailto:mhareed@rffcargo.co.ke" aria-label="Email for Operations Manager application">
                          mhareed@rffcargo.co.ke
                        </a>{' '}
                        with the subject line “Operations Manager Application.”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Careers;